import { render, staticRenderFns } from "./waterData.vue?vue&type=template&id=1a1c97c7&scoped=true&"
import script from "./waterData.vue?vue&type=script&lang=js&"
export * from "./waterData.vue?vue&type=script&lang=js&"
import style0 from "./waterData.vue?vue&type=style&index=0&id=1a1c97c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c97c7",
  null
  
)

export default component.exports